import { render, staticRenderFns } from "./ModalTopicEdit.vue?vue&type=template&id=5e3f971b&scoped=true"
import script from "./ModalTopicEdit.vue?vue&type=script&lang=js"
export * from "./ModalTopicEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f971b",
  null
  
)

export default component.exports